// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__mY9-M","label":"LabeledBox_label__FDT5C"};